import React from 'react';
import { Head } from 'react-static';

export default ({ image, pageDescription, pageTitle }) => {
  const title = `${pageTitle} | Northwestern Mutual`;
  const description = pageDescription;
  const productName = pageTitle;
  const url = 'https://www.northwesternmutual.com/who-we-are/';
  const imageAlt = 'A happy family with their financial plan figured out.';
  const publisher = 'Northwestern Mutual';
  const imageAbsolutePath = `https://www.northwesternmutual.com${image}`;

  return (
    <Head>
      <meta name='addsearch-category' content='Planning' />
      <meta name='keywords' content='About Northwestern Mutual, About Us, Who We Are' />
      <meta name='author' content={publisher} />
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
      <meta property='og:site_name' content={publisher} />
      <meta property='og:url' content={url} />
      <meta property='og:image' content={image} />
      <meta property='og:image:alt' content={imageAlt} />
      <meta property='og:type' content='website' />
      <meta property='og:locale' content='en_US' />
      <meta name='twitter:site' content='@NM_Financial' />
      <meta name='twitter:url' content={url} />
      <meta name='twitter:title' content={title} />
      <meta name='twitter:description' content={description} />
      <meta name='twitter:creator' content='@NM_Financial' />
      <meta name='twitter:creator:id' content='@NM_Financial' />
      <meta name="twitter:image" content={imageAbsolutePath} />
      <meta name='twitter:image:alt' content={imageAlt} />
      <meta name="twitter:card" content="summary_large_image" />

      <script type='application/ld+json'>
        {`{
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "${productName}",
            "description": "${description}",
            "publisher":
            {
              "@type": "FinancialService",
              "name": "${publisher}"
            },
            "url": "${url}"
          }`}
      </script>

      <script type='application/ld+json'>
        {`{
            "@context": "https://schema.org/",
            "@type": "Organization",
            "name": "${publisher}",
            "url": "${url}",
            "logo": "",
            "contactPoint": {
              "@type": "ContactPoint",
              "Telephone": "(866) 950-4644",
              "contactType": "customer service"
            },
            "sameAs": [
              "https://www.facebook.com/northwesternmutual",
              "https://twitter.com/nm_financial",
              "https://www.linkedin.com/company/northwestern-mutual",
              "https://instgram.com/northwesternmutual"
            ]
          }`}
      </script>

    </Head>
  );
};
